import React from 'react';
import I18n from 'i18n-js';
import { I18N as Translate } from '@reverbdotcom/commons/src/components/translate';
import { RCModal } from '@reverbdotcom/cadence/components';
import { Paths } from '../shared/url_helpers';

export function SecureCheckoutMessage() {
  const [isModalOpen, toggleModal] = React.useState(false);
  const openModal = () => toggleModal(true);

  return (
    <>
      <div className="secure-checkout-message">
        <button
          className="secure-checkout-message__trigger"
          type="button"
          onClick={openModal}
        >
          {I18n.t('discovery.secureCheckoutMessage.secureCheckout')}
        </button>
      </div>
      <RCModal
        isOpen={isModalOpen}
        onOpenChange={toggleModal}
        title={I18n.t('discovery.secureCheckoutMessage.securityInfo')}
      >
        <h3 className="size-120 weight-bold scaling-mb-6">
          {I18n.t('discovery.secureCheckoutMessage.howDoesReverbSecureInfo')}
        </h3>
        <p className="scaling-mb-4">
          {I18n.t('discovery.secureCheckoutMessage.cardsUseTLS')}
        </p>
        <p className="mb-0">
          <Translate
            html
            text="discovery.secureCheckoutMessage.stillHaveQuestions"
            args={{ linkOpen: `<a href="${Paths.helpCenterNewRequest.expand({ })}" target="_blank">`, linkClose: '</a>' }} />
        </p>
      </RCModal>
    </>
  );
}
